import type { i18n } from "i18next";
import type { SupportedLocale } from "./displayDate";
import { displayDateWithTime } from "./displayDateWithTime";

export const momentLocaleFor = (lng: string | undefined): SupportedLocale =>
  lng?.toLowerCase().startsWith("no") ? "nb" : "en";

export const registerI18nFormatters = (instance: i18n): void => {
  instance.services.formatter?.add("datetime", (value, lng) => {
    if (typeof value !== "string") return String(value);
    const language = lng ?? "en";
    const at = instance.getFixedT(language)("at");
    return displayDateWithTime(value, at, momentLocaleFor(language));
  });
};
